<template>
	<div id="multiselectbudget"  :class="{ 'd-flex flex-column align-items-center': isPhone }" >
		<div class="dropdown dropdown-filter" @click="showDropdown">
			<div class="overselect"></div>
			<div class="c-form-input">
				<h3 class="raleway-semi-p13">Budget</h3>
				<img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
				<img src="../../images/flechebas-simple.svg" v-set-alt v-else />
			</div>
		</div>
		<div class="multiselect" v-if="show":style="isPhone ? { width: '93%' } : {}">
			<Sliderbudget @changedBudget="changedBudget"></Sliderbudget>
		</div>
	</div>
</template>

<script>
	import Sliderbudget from 'pages/destinations/Sliderbudget';

	export default {
		name: 'multiselectbudget',
		components: { Sliderbudget },
		props: ['options'],
		data() {
			return {
				show: false,
				selected: [],
			};
		},
		methods: {
			showDropdown() {
				this.show = !this.show;
			},
			changedBudget(value) {
				this.$emit('changedBudget', value);
			},
		},
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        } else {
          return false;
        }
      },
    }
		// watch: {
		//   selected(val) {
		//     this.$emit('checked', val)
		//   }
		// }
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter"></style>